export default "__VITE_ASSET__DF88YQYI__"